module.exports = "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 a_position;\n\nvoid main() {\n   gl_Position = vec4(a_position,0.0,1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/js/screens/Screen3/water/shaders/simple.vert
// module id = 398
// module chunks = 0